export default __webpack_public_path__ + "static/media/freedomSlideImg.5351765e.png";